import React, {Suspense} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Configuration from './components/Configuration/config';
import TabContainer from './components/TabContainer/tabContainer';
import NewMessage from './components/NewMessage/newMessage';
import './App.scss';
import ErrorPage from "./components/ErrorPage/errorPage";
import TopicManagement from "./components/Topics/TopicManagement";
import NewTopic from "./components/Topics/NewTopic";
import UserSettings from "./components/UserSettings/UserSettings";
import Gallery from "./components/Gallery/Gallery";
import Welcome from "./components/Welcome/Welcome";
import {Flex, Image, Loader} from '@fluentui/react-northstar';
import * as microsoftTeams from "@microsoft/teams-js";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import {AppContext, IAppContextState} from "./services/AppContext";
import CompanyCommunicatorLogo from "./assets/ccp.webp";
import TelemetryService from "./services/TelemetryService/TelemetryService";
import {MailingLists} from "./components/MailingLists/MailingLists";
import {EditMailingList} from "./components/MailingLists/EditUsersList/EditMailingList";

interface IAppState {
    enableAppInsights: boolean
    loading: boolean
}

class App extends React.Component<{}, IAppState> {
    // Define component context
    static contextType = AppContext;
    context!: IAppContextState;

    constructor(props: {}) {
        super(props)
        this.state = {
            loading: true,
            enableAppInsights: false
        }
    }

    componentDidMount = () => {
        this.setState({loading: false});
        if (this.context.teams.isTeamsApp) microsoftTeams.app.notifySuccess();
    }

    withBanner = (children: JSX.Element): JSX.Element => {
        if (this.context.teams.isTeamsApp || this.context.teams.isTeamsIframe) return children;
        return (
            <Flex fill column>
                <Flex className={"top-banner"}>
                    <Image width={"200px"} height={"auto"} src={CompanyCommunicatorLogo}/>
                </Flex>
                <Flex fill>
                    {children}
                </Flex>
            </Flex>
        )
    }

    render() {
        if (this.state.loading) return <Loader style={{height: "100%"}}/>
        return (
            <Suspense fallback={<></>}>
                <ErrorBoundary>
                    <div className={"fill-absolute"}>
                        <div className={"app-container"}>
                            <BrowserRouter>
                                <TelemetryService enableAppInsights={this.state.enableAppInsights}>
                                    <Routes>
                                        <Route
                                            path="/configtab"
                                            element={<Configuration/>}
                                        />
                                        <Route
                                            path="/messages"
                                            element={this.withBanner(<TabContainer/>)}
                                        />
                                        <Route
                                            path="/topics"
                                            element={this.withBanner(<TopicManagement/>)}
                                        />
                                        <Route
                                            path="/gallery"
                                            element={this.withBanner(<Gallery/>)}
                                        />
                                        <Route
                                            path="/welcome"
                                            element={this.withBanner(<Welcome/>)}
                                        />
                                        <Route
                                            path="/newtopic"
                                            element={this.withBanner(<NewTopic/>)}
                                        />
                                        <Route
                                            path="/newtopic/:id"
                                            element={this.withBanner(<NewTopic/>)}
                                        />
                                        <Route
                                            path="/newmessage"
                                            element={this.withBanner(<NewMessage/>)}
                                        />
                                        <Route
                                            path="/newmessage/:id"
                                            element={this.withBanner(<NewMessage/>)}
                                        />
                                        <Route
                                            path="/users-lists"
                                            element={this.withBanner(<MailingLists/>)}
                                        />
                                        <Route
                                            path="/users-lists/:id"
                                            element={this.withBanner(<EditMailingList/>)}
                                        />
                                        <Route path="/errorpage" element={<ErrorPage/>}/>
                                        <Route path="/errorpage/:id" element={<ErrorPage/>}/>
                                        <Route path="/user-settings" element={<UserSettings/>}/>
                                    </Routes>
                                </TelemetryService>
                            </BrowserRouter>
                        </div>
                    </div>
                </ErrorBoundary>
            </Suspense>
        );
    }
}

export default App;